import { isDevelopmentEnvironment } from "@/lib/env";

// Ligado: a funcionalidade só aparece fora de produção (localhost e homologação/DEV), usando a mesma
// verificação de ambiente do resto do sistema (@/lib/env). Desligue (false) para liberar em produção.
export const CUSTOMER_GROUP_ADDRESS_DEV_ONLY = true;

export let isCustomerGroupAddressEnabled = false;

// Cadastro de grupos de cliente (importação do CSV do Magento) e de endereços de cobrança e entrega do cliente
// CNPJ: página Backoffice > Clientes > Grupos de cliente, grupo e aba "Endereços" no detalhe do cliente, coluna e
// filtro de grupo na lista de clientes, e escolha do endereço de entrega ao realizar o pedido. Desligada, as telas
// ficam como antes.
// Comente a linha abaixo para desativar a funcionalidade no frontend.
// Mantenha em sincronia com Features/CustomerGroupAddressFeature.cs do backend.
isCustomerGroupAddressEnabled = !CUSTOMER_GROUP_ADDRESS_DEV_ONLY || isDevelopmentEnvironment;
